import React from 'react'
import clsx from 'clsx'
import { Container, Grid, Paper } from '@material-ui/core';

import { useStyles } from '../Style/StyleAdmin';
import PagamentoPage from '../Page/PagamentoPage'
import FilterPage from '../Page/FilterPage'
import NoActivity from '../Page/NoActivity'
import Cart from '../../components/Cart'
import { useHistory } from 'react-router-dom';



function Pagamento() {
  const classes = useStyles();
  const history = useHistory();

  const irResumo = () => {
    history.push('resumo');
    console.log('foi')
    
  };

  

  return(
    <div style={{background:'#f0f0f0', margin:10}}> 

      <Grid container spacing={3}>
        {/* Product */}
        <Grid item xs={12} md={9} lg={9}>
        
            <PagamentoPage />
    
        </Grid>
 
        {/* Activity */}
        <Grid item xs={12} md={3} lg={3}>
          <Paper className={clsx(classes.paper, classes.fixedHeight)}>
          <Cart IrFrete={irResumo}  />

          {/* <NoActivity/> */}
          </Paper>
        </Grid>
      </Grid>

    </div>
  )
}

export default Pagamento;
